import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@@common';
import { useNotificationRefetch, useNotificationSubscription, useNotifications } from '@@components';

import { EmbedDefinitionClient, EmbedDeploymentClient } from '../../../api/api';

export function useEmbedDefinitions() {
	const client = useApiClient(EmbedDefinitionClient);
	return useQuery({ queryKey: ['embedDefinitions'], queryFn: ({ signal }) => client.get(signal) });
}
export function useEmbedDeployments(environmentId?: string) {
	const client = useApiClient(EmbedDeploymentClient);
	useNotificationSubscription('environment', environmentId);
	const { latestReleasePlanEvent } = useNotifications();
	const query = useQuery({
		queryKey: ['embedDeployments', environmentId],
		enabled: !!environmentId,
		queryFn: ({ signal }) => client.get(environmentId!, signal),
	});
	useNotificationRefetch({
		notification: latestReleasePlanEvent,
		getKey: (event) => event.payload.id + ':' + event.receivedAt,
		shouldRefetch: (event) => event.payload.targetEnvironmentId === environmentId,
		refetch: query.refetch,
	});
	return query;
}
